<template>
  <div id="color">
    <div class="div_line">
      参数设置1：当数值为
      <!-- <Input v-model="minNumOne" type="number" placeholder style="width: 50px"/> -->
      <!-- <InputNumber v-model="minNumOne" :max="maxNumOne" :min="15"  style="width: 50px"></InputNumber> -->
      <Input type="number" @on-blur="oneChange" v-model="minNumOne" style="width: 50px"></Input>
      <!-- <Input
        type="number"
        @on-blur="inputChange(minNumOne,maxNumOne,15)"
        v-model="minNumOne"
        style="width: 50px"
      ></Input>-->

      <span>至</span>
      <!-- <InputNumber v-model="maxNumOne" :max="30" :min="minNumOne" style="width: 50px"></InputNumber> -->
      <Input type="number" @on-blur="oneMaxChange" v-model="maxNumOne" style="width: 50px"></Input>

      <span>
        时为
        <i class="select_color"></i>色
        <span v-if="!showAddTwo" @click="showTwo" class="add_span">+</span>
      </span>
    </div>
    <div v-if="showAddTwo" class="div_line">
      <span @click="showTwo" class="add_span">-</span>
      参数设置2：当数值为
      <!-- <InputNumber v-model="minNumTwo" :max="maxNumTwo" :min="31" style="width: 50px"></InputNumber> -->
      <Input type="number" @on-blur="twoChange" v-model="minNumTwo" style="width: 50px"></Input>

      <span>至</span>
      <!-- <InputNumber v-model="maxNumTwo" :max="40" :min="minNumTwo" style="width: 50px"></InputNumber> -->
      <Input type="number" @on-blur="twoMaxChange" v-model="maxNumTwo" style="width: 50px"></Input>

      <span>
        时为
        <i class="select_color_two"></i>色
      </span>
      <span v-if="!showAddThr" @click="showThr" type="number" class="add_span">+</span>
      <!-- <span v-else @click="showThr" type="number" class="add_span">-</span>-->
    </div>

    <div v-if="showAddThr" class="div_line">
      <span @click="showThr" type="number" class="add_span">-</span>
      参数设置3：当数值为
      <Input @on-blur="thrChange" v-model="minNumThr" type="number" style="width: 50px" />
      <span>至</span>
      <Input v-model="maxNumThr" type="number" style="width: 50px" />
      <span>
        时为
        <i class="select_color_thr"></i>色
      </span>
    </div>
    <span @click="inputChange" class="affirm">确认</span>
  </div>
</template>
<script>
import { mapState } from "vuex";
// let host = window.location.host;
export default {
  name: "color",
  data() {
    return {
      value1: 1,
      count: "",
      minNumOne: 15,
      maxNumOne: 30,
      minNumTwo: 31,
      maxNumTwo: 40,
      minNumThr: 41,
      maxNumThr: 50,
      showAddTwo: false,
      showAddThr: false
    };
  },
  computed: {
    ...mapState(["systemInfo"])
  },
  methods: {
    // inputChange(min, max, num) {
    //   if (this[min] < this[num]) {
    //     this[min] = this[num];
    //   } else if (this[min] > this[max]) {
    //     this[min] = this[max];
    //   }
    //   console.log(this[min], this[max], "sssdsdsdsdsd");
    // },

    oneChange() {
      if (this.minNumOne < 15) {
        this.minNumOne = 15;
      } else if (this.minNumOne > this.maxNumOne) {
        this.minNumOne = this.maxNumOne;
      }
    },
    oneMaxChange() {
      if (this.maxNumOne < this.minNumOne) {
        this.maxNumOne = this.minNumOne;
      } else if (this.maxNumOne > 30) {
        this.maxNumOne = 30;
      }
    },
    twoChange() {
      if (this.minNumTwo < 31) {
        this.minNumTwo = 31;
      } else if (this.minNumTwo > this.maxNumTwo) {
        this.minNumTwo = this.maxNumTwo;
      }
    },
    twoMaxChange() {
      if (this.maxNumTwo < this.minNumTwo) {
        this.maxNumTwo = this.minNumTwo;
      } else if (this.maxNumTwo > 40) {
        this.maxNumTwo = 40;
      }
    },
    thrChange() {
      if (this.minNumThr < 41) {
        this.minNumThr = 41;
      } else if (this.minNumThr > this.maxNumThr) {
        this.minNumThr = this.maxNumThr;
      }
    },
    thrMaxChange() {
      if (this.maxNumThr < this.minNumThr) {
        this.maxNumThr = this.minNumThr;
      } else if (this.maxNumThr > 50) {
        this.maxNumThr = 50;
      }
    },
    showTwo() {
      this.showAddTwo = !this.showAddTwo;
    },
    showThr() {
      this.showAddThr = !this.showAddThr;
    },
    inputChange() {
      var arr = [this.minNumOne, this.maxNumOne];
      if (this.showAddTwo) {
        var a = [this.minNumTwo, this.maxNumTwo];
        arr = arr.concat(a);
      }
      if (this.showAddThr) {
        var a1 = [this.minNumThr, this.maxNumThr];
        arr = arr.concat(a1);
      }
      this.$emit("inputNum", arr);
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/components/ColorFiltrate/index.vue